import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpRequest } from '@angular/common/http';
import { Globals } from '../globals';
import { map, catchError } from 'rxjs/operators';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})


export class FlowMeterService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');
    }

    // Method is used for Add Company
    GetFlowMeterGraphData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/GetFlowMeterGraphData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    GetCustomGraphData(ReqObj: any) {       
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/GetCustomGraphData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }    

    // Method is used for Add Company
    GetMeterDataCount(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/GetMeterDataCount';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get Report Data
    GetFlowMeterReportData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/GetFlowReportData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Update Flow Meter parameter
    UpdateFlowParameter(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/UpdateFlowParameter';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get Flow Meter parameter
    GetFlowParameter(DeviceId) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/GetFlowParameter?DeviceId=' + DeviceId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Get Flow Meter parameter
    GetLatestMeterValue(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'FlowMeter' + '/GetLatestMeterValue';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}
